// extracted by mini-css-extract-plugin
module.exports = {"container":"AppPage_container__rDf4N"};